module.exports = __webpack_public_path__ + "img/img4.1b5da047.png";